import { useCities } from '../providers/cities';
import { useAuth } from '../providers/auth';

export const useCity = () => {
  const { selectedCity } = useCities();
  const { user } = useAuth();

  return {
    canRegisterAnonymously: !selectedCity?.only_registered && !user,
  };
};
